import { render, staticRenderFns } from "./kendedaDTW_model.vue?vue&type=template&id=3bde0fb6&"
import script from "./kendedaDTW_model.vue?vue&type=script&lang=js&"
export * from "./kendedaDTW_model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports